import { render, staticRenderFns } from "./OnePup.vue?vue&type=template&id=36595cc0&scoped=true"
import script from "./OnePup.vue?vue&type=script&lang=js"
export * from "./OnePup.vue?vue&type=script&lang=js"
import style0 from "./OnePup.vue?vue&type=style&index=0&id=36595cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36595cc0",
  null
  
)

export default component.exports